<template>
  <!-- Desktop -->
  <div v-if="!mobile" class="space-y-5">
    <TrafficStatCards :duration="duration" />

    <VisitorsOverTime :duration="duration" />

    <div class="grid grid-cols-3 gap-4">
      <div class="col-span-2">
        <CountryMap :duration="duration" />
      </div>
      <CountryTable :duration="duration" />
    </div>

    <DeviceBreakdown :duration="duration" />
  </div>

  <!-- Mobile: single column -->
  <div v-else class="space-y-4">
    <TrafficStatCards   :duration="duration" />
    <VisitorsOverTime   :duration="duration" />
    <CountryMap         :duration="duration" />
    <CountryTable       :duration="duration" />
    <DeviceBreakdown    :duration="duration" />
  </div>
</template>

<script setup>
import { onMounted, watch } from 'vue'
import { useAnalyticsTrafficStore } from 'stores/analyticsTraffic.js'
import TrafficStatCards  from './TrafficStatCards.vue'
import VisitorsOverTime  from './VisitorsOverTime.vue'
import CountryMap        from './CountryMap.vue'
import CountryTable      from './CountryTable.vue'
import DeviceBreakdown   from './DeviceBreakdown.vue'

const props = defineProps({
  duration: { type: String, required: true },
  mobile:   { type: Boolean, default: false },
})

const store = useAnalyticsTrafficStore()

async function load() {
  await store.fetchAll(props.duration)
}

onMounted(load)
watch(() => props.duration, load)
</script>
